export default "__VITE_ASSET__CXsgvlBA__"